<template>
<div id="dataTable_filter" class="dataTables_filter input-group" style="margin-bottom: 0.5rem;flex-wrap: nowrap;">
  <span class="d-flex" v-if="query && query.length >= charThreshold"><p v-if="hitsAmount" class="text-center mt-2 mb-0">Displaying Search Results for "<strong>{{query}}</strong>"</p>
  <p v-if="!hitsAmount && (result.length || query)" class="text-center mt-2 mb-0"><strong class="text-danger">No Results</strong> found for "<strong>{{query}}</strong>"</p>
  <button @click="clearSearch()" class="ml-2 btn btn-sm btn btn-outline-secondary">Clear Search</button></span>
  <input class="form-control" placeholder="Search Jobs" 
    type="search"
    v-model="query"
  />
  

 <div class="input-group-append"><div class="btn" style="background:#fff;border-right:1px solid #d1d3e2;border-bottom:1px solid #d1d3e2;border-top:1px solid #d1d3e2;"><i class="fas fa-search fa-sm"></i></div></div></div>
</template>

<script>
import { connectSearchBox } from 'instantsearch.js/es/connectors';
import { createWidgetMixin } from 'vue-instantsearch';

export default {
  mixins: [createWidgetMixin({ connector: connectSearchBox })],
  props: {
    hitsAmount: {
      type: Number,
      default: 0,
      required: false,
    },
    result: {
      type: String,
      required: false,
    },
    delay: {
      type: Number,
      default: 200,
      required: false,
    },
  },
  data() {
    return {
      localQuery: '',
      initSearch:false,
      charThreshold: 3,
    };
  },
  created(){
      this.query = sessionStorage.getItem('searchQuery');
  },
  destroyed() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    if(this.localQuery.length >= this.charThreshold){
      sessionStorage.setItem('searchQuery', this.localQuery);
    }else{
      sessionStorage.clear('searchQuery');
    }
  },
  computed: {
    query: {
      get() {
        return this.localQuery;
      },
      set(val) {
        console.log('search', val);
         this.localQuery = val;
       if(val.length < this.charThreshold){
            this.state.refine('');
            return
        }
        this.timeoutId = setTimeout(() => {
          this.state.refine(this.localQuery);
          this.initSearch = true;
        }, this.delay);
      },
    },
  },
    methods: {
        clearSearch(){
            console.log("Clear");
            sessionStorage.clear('searchQuery');
            this.query = '';
            this.localQuery = '';
        }
  }
};
</script>
